import { isEqual } from 'lodash';

interface ConditionalRule {
  fieldName: string
  value: string
}

export const getConditionalRules = (rules: unknown): ConditionalRule[] => {
  const parsedRules: unknown[] = typeof rules === 'string'
    ? rules.split('|').map((rule) => {
      const separator = rule.indexOf(':');
      return { name: rule.slice(0, separator), value: rule.slice(separator + 1) };
    })
    : Array.isArray(rules) ? rules : [];

  return parsedRules.reduce<ConditionalRule[]>((result, rule) => {
    if (!rule || typeof rule !== 'object') { return result; }
    const { name, value } = rule as { name?: unknown, value?: unknown };
    if ((name !== 'required_if' && name !== 'required_if_in') || typeof value !== 'string') {
      return result;
    }
    const separator = value.indexOf(',');
    if (separator < 1) { return result; }
    const fieldName = value.slice(0, separator).trim();
    if (fieldName) {
      result.push({ fieldName, value: value.slice(separator + 1) });
    }
    return result;
  }, []);
};

const getExpectedValues = (expected: unknown): unknown[] => {
  let parsed: unknown = expected;
  if (typeof expected === 'string') {
    try {
      parsed = JSON.parse(expected);
    } catch {
      return expected.split(',');
    }
  }
  if (Array.isArray(parsed)) { return parsed; }
  if (parsed && typeof parsed === 'object') { return Object.values(parsed); }
  return [parsed];
};

export const matchesConditionalValue = (actual: unknown, expected: unknown): boolean => {
  if (actual === undefined || actual === null) { return false; }
  const actualValues: unknown[] = Array.isArray(actual) ? actual : [actual];
  const expectedValues = getExpectedValues(expected);
  return actualValues.some(value => value !== undefined && value !== null
    && expectedValues.some(candidate => (
      (typeof value === 'object' || (candidate !== null && typeof candidate === 'object'))
        ? isEqual(value, candidate)
        : String(value) === String(candidate)
    )));
};
